import { useQuery } from 'react-query'
import { projectUseCase } from '../../factories'

const useListProjects = (variables) => {
  const {
    refetch: listProjects, isLoading, data, error,
  } = useQuery('projects', () => projectUseCase.listProjects(variables))

  return {
    listProjects,
    isLoading,
    error,
    data,
  }
}

export default useListProjects
